
import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-wow-fade-in-up',
	templateUrl: './wow-fade-in-up.component.html',
	styleUrls: ['./wow-fade-in-up.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class WowFadeInUpComponent implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';

	constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Wow scroll');
		_dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}
	ngOnInit() {
		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}
	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}
	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'wow-fade-in-up') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('wow-fade-in-up');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/features/wow-slider/wow-fade-in-up/wow-fade-in-up.component.ts